"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isoCountryCodeMap = exports.countryCodeIsoMap = exports.THLegacyCountryCode = exports.isIsoCountryCode2Char = exports.TIsoCountryCode2Char = exports.UPPER_CASE_COUNTRY_NAME_TO_ISO2_MAPPING = void 0;
const mapping_1 = require("../../utils/mapping");
const generated_1 = require("./generated");
/**
 * Maps an upper case country name to the 2-char ISO Code
 */
exports.UPPER_CASE_COUNTRY_NAME_TO_ISO2_MAPPING = {
    ...generated_1.UPPER_CASE_COUNTRY_NAME_TO_ISO2_MAPPING_GENERATED,
    ['ANDORRA']: generated_1.IsoCountryCode2Char.ES /** Andorra and gibraltar managed under the Spain  */,
    ['GIBRALTAR']: generated_1.IsoCountryCode2Char.ES,
    ['GREAT BRITAIN']: generated_1.IsoCountryCode2Char.GB,
    ['KOREA']: generated_1.IsoCountryCode2Char.KR,
    ['UNIT. ARAB EMIR']: generated_1.IsoCountryCode2Char.AE,
};
exports.TIsoCountryCode2Char = new mapping_1.Enum(generated_1.IsoCountryCode2Char);
function isIsoCountryCode2Char(val) {
    try {
        mapping_1.cast(val, exports.TIsoCountryCode2Char);
    }
    catch (err) {
        return false;
    }
    return true;
}
exports.isIsoCountryCode2Char = isIsoCountryCode2Char;
var THLegacyCountryCode;
(function (THLegacyCountryCode) {
    THLegacyCountryCode["CAN"] = "CA";
    THLegacyCountryCode["USA"] = "US";
})(THLegacyCountryCode = exports.THLegacyCountryCode || (exports.THLegacyCountryCode = {}));
// provide a reverse-lookup of the same
exports.countryCodeIsoMap = new Map(Object.entries(THLegacyCountryCode).map(([key, value]) => [
    value,
    generated_1.IsoCountryCode[key],
]));
// provide a conversion table between ISO country code values and Tim Hortons
exports.isoCountryCodeMap = new Map(Object.entries(generated_1.IsoCountryCode).map(([key, value]) => [
    value,
    THLegacyCountryCode[key],
]));
//# sourceMappingURL=utils.js.map